import React, { Fragment, useContext } from 'react';
import { PageStateContext } from '../../context/PageStateContext';

import { getSlackFilesUrl } from '../../utilities/urlHelper';
import ChangePageOwner from '../page/ChangePageOwner';
import ChangePagePermissions from './ChangePagePermissions';
import StartFromTemplateWrapper from './StartFromTemplateWrapper';
import EditorHelpModalWrapper from './EditorHelpModal';

const DraftDropdownOptions = ({ isNewDraft }) => (
    <Fragment>
        {isNewDraft && <StartFromTemplateWrapper />}
        <ChangePageOwner isDraft />
        <ChangePagePermissions />
    </Fragment>
);

export default () => {
    const { pageState } = useContext(PageStateContext);
    const { isNewDraft, isTemplateDraft } = pageState || {};
    return (
        <div className="dropdown dropdown-right-aligned ml1" data-disclosure="">
            <button className="top-nav-btn dropdown-link dropdown-elipsis" type="button" aria-label="open options menu">
                <img className="button-icon" height="18" width="4" src="/img/icons/dropdown-elipsis.svg" aria-hidden="true" alt="dropdown icon" />
            </button>
            <div data-details="" className="dropdown-overlay" style={{ display: 'none' }} />
            <div data-details="" className="dropdown-content" style={{ display: 'none' }}>
                {!isTemplateDraft ? <DraftDropdownOptions isNewDraft={isNewDraft} /> : null}
                <EditorHelpModalWrapper text="Help" />
            </div>
        </div>
    );
};
